const INIT_STATE = {
  type:'info',
  id:'',
  codeIndex:'',
  content:'',
  archives:[],
  active:[]
};

export default (state = INIT_STATE, action) => {
  var stateRefresh = (action.payload) ? action.payload : action;
      stateRefresh = (stateRefresh.response) ? stateRefresh.response : {};
  switch (action.type) { 
    case "error":
      return { ...state,
               ...action,
      };
    break;
    default:
      return { ...state,
        ...stateRefresh,
};
    break;
  }
};
